import type { AxiosApiError } from '@/types/common/ResponseErrorType';

const DEFAULT_MESSAGE = 'エラーが発生しました。';

function extractErrorData(error: unknown) {
  const err = error as AxiosApiError;
  return err.response?.data ?? err.data;
}

export function extractApiStatus(error: unknown): number | undefined {
  const err = error as AxiosApiError;
  return err.response?.status ?? err.status;
}

/**
 * API エラーからメッセージを抽出する。
 * エラーレスポンス形式が統一されていないため、複数パターンを試行する。
 */
export function extractApiErrorMessage(error: unknown, fallback = DEFAULT_MESSAGE): string {
  const data = extractErrorData(error);
  return data?.message || data?.error?.message || data?.error?.id || fallback;
}

export function extractFirstFieldErrorMessage(error: unknown): string | null {
  const data = extractErrorData(error);
  const fieldErrors = data?.field_error;
  if (!Array.isArray(fieldErrors) || fieldErrors.length === 0) return null;
  return fieldErrors[0]?.message ?? null;
}

/** 401/404 の場合は true */
export function isAuthOrNotFoundError(error: unknown): boolean {
  const status = extractApiStatus(error) ?? 0;
  return [401, 404].includes(status);
}
